import React from 'react';

import Slider from '../slider/slider';
import Anchor from '../anchor/anchor';

import './photostory.css';

const PhotoStory = () => (
    <div className="photostory">
        <Anchor id="photostory" />
        <div className="photostory__bg-images">
            <img alt="" className="photostory__bg-image" src="./images/index/anton.svg" />
            <img alt="" className="photostory__bg-image" src="./images/index/stars.svg" />
            <img alt="" className="photostory__bg-image" src="./images/index/clouds.svg" />
        </div>
        <div className="photostory__title">Фотоистория</div>
        <Slider />
    </div>
);

export default PhotoStory;
